import React from 'react';

import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import UFOSegment from '@atlaskit/react-ufo/segment';
import { AtlassianRelayEnvironmentProvider } from '@atlassian/relay-environment-provider';

import { ConversationAssistantConfigurer } from './ConversationAssistantConfigurer';
import { ConversationAssistantConfigurerV2 } from './ConversationAssistantConfigurerV2';

export const ConversationAssistant = ({
	skipRelayProvider,
	...props
}: Parameters<typeof ConversationAssistantConfigurerV2>[0] & {
	skipRelayProvider?: boolean;
}): React.JSX.Element => {
	// Mounts that skip the chat UI still initialise the shared providers, the global chat store and the
	// bridge API handlers. `overridingChildren` is the legacy signal for the same intent, so it keeps
	// implying the chat UI is skipped.
	const shouldSkipChatUI = props.skipChatUI ?? Boolean(props.overridingChildren);

	const rootSegmentName = shouldSkipChatUI
		? 'rovo-conversation-assistant-wOverriddenChildren'
		: 'rovo-conversation-assistant';

	const content = isExperimentEnabled('rovo_chat_configurer_v2_split_out_ui') ? (
		<ConversationAssistantConfigurerV2 {...props} />
	) : (
		<ConversationAssistantConfigurer {...props} />
	);

	return (
		// The UFOSegment has to be absolute top, please do not introduce any side effects in this parent level component,
		// otherwise it may not get captured with performance metrics
		<UFOSegment name={rootSegmentName}>
			{skipRelayProvider && fg('ai_agent_sessions_warming_cache') ? (
				content
			) : (
				<AtlassianRelayEnvironmentProvider>{content}</AtlassianRelayEnvironmentProvider>
			)}
		</UFOSegment>
	);
};
